import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { builderRedirect } from '../utils/documentAccess';
import './SSOCallback.css';

function SSOCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginFromSSO } = useAuth();
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('Authenticating...');

  useEffect(() => {
    const token = searchParams.get('token');
    const signature = searchParams.get('signature');

    if (!token || !signature) {
      setError('Missing authentication parameters. Please try again from your WordPress admin.');
      return;
    }

    exchangeToken(token, signature);
  }, []);

  const exchangeToken = async (token, signature) => {
    try {
      setStatus('Verifying credentials...');
      const response = await api.post('/auth/sso/exchange', { token, signature });

      setStatus('Setting up your session...');
      await loginFromSSO(response.data);

      // Store return URL so user can navigate back to the main app
      // Prefer the URL param (from WP component click) over the SSO payload
      const returnUrl = searchParams.get('return_url') || response.data.returnUrl;
      if (returnUrl) {
        localStorage.setItem('returnUrl', returnUrl);
      }

      const redirect = builderRedirect(searchParams.get('redirect'), response.data.customerDocsOnly);
      navigate(redirect, { replace: true });
    } catch (err) {
      const message = err.response?.data?.error || 'Authentication failed. Please try again.';
      setError(message);
    }
  };

  return (
    <div className="sso-callback">
      <div className="sso-callback-card">
        {error ? (
          <>
            <div className="sso-error-icon">!</div>
            <h2>Authentication Failed</h2>
            <p className="sso-error-message">{error}</p>
            <p className="sso-error-hint">
              Please close this tab and try again from your main application.
            </p>
          </>
        ) : (
          <>
            <div className="sso-spinner" />
            <h2>{status}</h2>
            <p className="sso-hint">Please wait while we set up your session...</p>
          </>
        )}
      </div>
    </div>
  );
}

export default SSOCallback;
